import { baseReducer } from '../../store/core/base-reducer';
import * as Actions from './country.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

const initialState = {
  countryConfig: undefined,
};

const actionHandlerMap = {
  [Actions.SET_COUNTRY_CONFIG]: (state, { countryConfig }) => {
    return {
      ...state,
      countryConfig,
    };
  },
  [APP_INITIALIZATION]: (state, { initialData }) => {
    return {
      ...state,
      countryConfig: initialData.countryConfig,
    };
  },
};

export const ConnectedActionHandlerMap = baseReducer(initialState, actionHandlerMap);

export { namespace } from './country.reducer.metadata';
